import { apiRequest } from '../../api/client';

let inFlightTicket = null;
let inFlightPromise = null;

export async function claimImpersonationTicket(ticket) {
  const value = String(ticket || '').trim();
  if (!value) throw new Error('Missing impersonation ticket.');
  if (inFlightTicket === value && inFlightPromise) {
    return inFlightPromise;
  }
  inFlightTicket = value;
  inFlightPromise = apiRequest('/api/auth/impersonation/claim', {
    method: 'POST',
    body: { ticket: value },
  }).catch((error) => {
    if (inFlightTicket === value) {
      inFlightTicket = null;
      inFlightPromise = null;
    }
    throw error;
  });
  return inFlightPromise;
}
